<template>
  <DashboardLayout
    v-if="loaded"
    :me="me"
    :sidebar-title="settings.site_name"
    :sidebar-short-title="sidebarShortTitle"
    :sidebar-links="sidebarLinks"
    :sidebar-background="sidebarBackground"
    :show-footer="$route.meta.showFooter"
    :footer-website="footerWebsite"
    :footer-company="footerCompany"
    :footer-year="footerYear"
    @logout="logout" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import routes from 'src/router/routes';
import DashboardLayout from './_components/DashboardLayout';

export default {
  name: 'DashboardModule',
  components: {
    DashboardLayout,
  },
  data() {
    return {
      loaded: false,
      footerWebsite: 'https://www.exnihilodev.com',
      footerCompany: 'Ex Nihilo Studios',
      footerYear: `2019 - ${new Date().getFullYear()}`,
      sidebarShortTitle: '',
      sidebarBackground: 'primary', // vue|blue|orange|green|red|primary
    };
  },
  async created() {
    await this.$store.dispatch('me/fetchMe');
    if (this.hasAdminRole) {
      await this.$store.dispatch('settings/fetchSettings');
    } else {
      await this.$store.dispatch('settings/fetchPublicSettings');
    }
    // Genereate short title from initials. ex. Ex Nihilo Admin => ENA
    this.sidebarShortTitle = this.settings.site_name
      .split(' ')
      .map(word => word[0])
      .join('');

    this.loaded = true;
  },
  methods: {
    logout() {
      this.$store.dispatch('authentication/logout');
      this.$router.push({ name: 'Login' });
    },
  },
  computed: {
    ...mapState('me', {
      me: state => state.account,
    }),
    ...mapState('settings', {
      settings: state => state.settings,
    }),
    ...mapGetters('me', [
      'hasAdminRole',
    ]),
    sidebarLinks() {
      // get all the routes that should be included in the sidebar
      const linkRoutes = routes[0].children.filter((route) => {
        // don't include links that this user is not authorized to view
        // actual authorization checking is handled at the router & server level
        let authorized = true;
        if (route.meta && route.meta.requiredRoles) {
          authorized = route.meta.requiredRoles.includes(this.me.role);
        }
        return route.meta && route.meta.sidebar && authorized;
      });
      return linkRoutes.map(route => ({
        name: route.meta.sidebar.name,
        icon: route.meta.sidebar.icon,
        path: route.path,
      }));
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'me.settings': function (settings) {
      if (settings.mini_sidebar === true) {
        this.$sidebar.minimize();
      } else if (settings.mini_sidebar === false) {
        this.$sidebar.maximize();
      }
    },
  },
};
</script>
